import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/collectible-card-total-background.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_download_2.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-53451990")

_pushScopeId("data-v-53451990")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex flex-col rounded-lg mt-4" }
const _hoisted_3 = { class: "relative overflow-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex z-10"
}
const _hoisted_5 = { class: "flex flex-col justify-center items-center" }
const _hoisted_6 = {
  key: 0,
  class: "relative"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "absolute inset-0 z-20 text-8px font-montserrat text-white text-shadow-border text-center mt-0.5" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-row px-3 py-4 justify-center items-center border border-gray-lp-200 rounded-b-lg cursor-pointer"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_skeleton = _resolveComponent("skeleton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_skeleton, {
        key: 0,
        class: "w-auto",
        height: "400px"
      }))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                alt: "Gold Digital Photocard",
                class: `w-full z-0 ${_ctx.modelValue && !_ctx.isImageError ? 'rounded-t-lg' : 'rounded-lg'}`,
                src: 
              `${
                _ctx.isImageError
                  ? require(`@/app/ui/assets/images/collectible-card-error-image.png`)
                  : _ctx.modelValue
                  ? require(`@/app/ui/assets/images/collectible-card-background.png`)
                  : require(`@/app/ui/assets/svg/collectible-card-lp-back.svg`)
              }`
            
              }, null, 10, ["src"]),
              (_ctx.modelValue && !_ctx.isImageError)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("img", {
                        src: _ctx.localPhotoCard,
                        class: _ctx.customClass,
                        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError && _ctx.onImageError(...args))),
                        onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageLoaded && _ctx.onImageLoaded(...args))),
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToDetailPage && _ctx.goToDetailPage(...args)))
                      }, null, 42, ["src"]),
                      (_ctx.isUsingTotal && !_ctx.isImageStillLoading && !_ctx.isImageError)
                        ? (_openBlock(), _createBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createVNode("div", _hoisted_8, " X" + _toDisplayString(_ctx.modelValue?.total), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.modelValue && !_ctx.isImageError)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode("div", {
                class: "font-montserrat text-12px font-semibold text-black-lp-200",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.downloadImage && _ctx.downloadImage(...args)))
              }, " Download ")
            ]))
          : _createCommentVNode("", true)
      ]))
})